module.exports = __webpack_public_path__ + "static/media/settings.d1118b10.png";